import './LegalLinks.css'

const SITE = 'https://www.adissoo.com'

/**
 * Gizlilik politikası, KVKK ve kullanıcı sözleşmesi bağlantıları (23 Eki
 * 2026). Apple kuralı 5.1.1: gizlilik politikası uygulamanın içinden de
 * açılabilmeli. Giriş ekranının altında ve Ayarlar > Hesabım'da.
 */
export function LegalLinks({ className = '' }: { className?: string }) {
  return (
    <nav className={`legal-links ${className}`} aria-label="Yasal metinler">
      <a href={`${SITE}/gizlilik`} target="_blank" rel="noopener">
        Gizlilik Politikası
      </a>
      <a href={`${SITE}/kvkk`} target="_blank" rel="noopener">
        KVKK
      </a>
      <a href={`${SITE}/kullanici-sozlesmesi`} target="_blank" rel="noopener">
        Kullanıcı Sözleşmesi
      </a>
    </nav>
  )
}
